import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../core/auth/auth-service.service';
import { BehaviorSubject } from 'rxjs';
import { ItemResponse } from '../models/item/item.model';
import { DomainInfo } from '../models/domainInfo/domainInfo.model';



@Injectable({
  providedIn: 'root'
})
export class MainContent {
  private apiOfficeware: String = environment.apiOfficeware;
  private apiDomainHost: String = environment.apiDomain;
  private apiUrlHost: String = environment.apiUrlHost;
  private dataSource = new BehaviorSubject<ItemResponse>({});
  searchAddResults = this.dataSource.asObservable();

  constructor(private http: HttpClient, private translate: TranslateService, public auth: AuthService) {

  }



  loadDownloadItems() {
    const url = `${this.apiOfficeware}download/v1/list?status=PENDING`;

    const token = this.auth.getToken();

    return this.http.get<any>(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,

      }
    });

  }

  viewDownload(id: string) {
    const url = `${this.apiOfficeware}download/v1/view/${id}`;

    const token = sessionStorage.getItem('authToken');

    return this.http.get<any>(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,

      }
    });
  }

  viewDownloadPublic(id: string) {
    const url = `${this.apiOfficeware}download/v1/viewPublic/${id}`;

    return this.http.get<any>(url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }



  createExternalToken(uniqueId: string, email: string, language: string, downloadId: string) {
    const url = `${this.apiDomainHost}/token`;

    return this.http.put<any>(url, {
      id: uniqueId,
      email: email,
      lang: language,
      downloadId: downloadId
    });
  }

  getToken(uniqueId: string, code: string, noExpirationToken: boolean) {
    let key: string;
    if (!noExpirationToken) {
      key = `${code}-${uniqueId}`;
    }
    else {
      key = `${uniqueId}`;
    }


    const url = `${this.apiDomainHost}/token?authToken=${key}`;

    return this.http.get<any>(url);
  }

  /**
   * Google Drive links need an Authorization header, which an <object> or a link cannot send, so
   * the file is requested to the download proxy with the session token and handled as a blob.
   * The proxy asks officeware whether this token may read the file (401 / 403 otherwise).
   */
  getGoogleFile(downloadId: string, fileId: string, option: 'View' | 'Download') {
    const url = `${environment.apiDownload}/file`;
    const token = sessionStorage.getItem('authToken');

    return this.http.get(url, {
      params: { downloadId, fileId, option },
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      responseType: 'blob',
      observe: 'response'
    });
  }

  sign(id: string, sign: string, comment?: string) {
    const url = `${this.apiOfficeware}download/v1/sign/${id}`;
    const token = sessionStorage.getItem('authToken');

    return this.http.post<any>(url, {
      sign: sign,
      comment: comment
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
  }

  accept(id: string, status: string, comment?: string) {
    const url = `${this.apiOfficeware}download/v1/sign/${id}`;
    const token = sessionStorage.getItem('authToken');

    return this.http.post<any>(url, {
      status: status,
      comment: comment
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
  }


  deleteChild(parentId: number, id: string, type: string) {
    const url = `${this.apiOfficeware}download/v1/delete?parentId=${parentId}&id=${id}&type=${type}`;
    const token = sessionStorage.getItem('authToken');

    return this.http.delete<any>(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
  }

  getDomainInfo(idDomain: string) {
    const url = `${this.apiDomainHost}/info?idDomain=${idDomain}`;
    const token = sessionStorage.getItem('authToken');
    return this.http.get<DomainInfo>(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
  }


}
